(function () {
  'use strict';

  var selector = '[data-subscription-card-price-usd]';
  var retries = 0;
  var maxRetries = 8;

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function getRate() {
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return Number.isFinite(rate) && rate > 0 ? rate : null;
  }

  function originalText(element) {
    if (!element) return '';
    if (!element.hasAttribute('data-subscription-card-original-price')) {
      element.setAttribute('data-subscription-card-original-price', element.textContent.trim());
    }
    return element.getAttribute('data-subscription-card-original-price') || '';
  }

  function format(cents, currency, sample) {
    var numberMatch = sample.match(/\d{1,3}(?:[,\s\u00a0]\d{3})*(?:[.,]\d+)?|\d+(?:[.,]\d+)?/);
    var sampleNumber = numberMatch ? numberMatch[0] : '';
    var decimalMatch = sampleNumber.match(/[.,](\d{1,2})$/);
    var fractionDigits = decimalMatch ? decimalMatch[1].length : 0;
    var amount;

    try {
      amount = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(cents / 100);
    } catch (error) {
      amount = (cents / 100).toFixed(fractionDigits);
    }

    // Keep the exact symbol, code placement, and precision Shopify rendered for this market.
    if (numberMatch) return sample.replace(sampleNumber, amount);
    return amount + ' ' + currency;
  }

  function setText(element, cents, currency) {
    if (element) element.textContent = format(cents, currency, originalText(element));
  }

  function convert(root) {
    var rate = getRate();
    if (rate === null) return false;

    var currency = getCurrency();
    root.querySelectorAll(selector).forEach(function (card) {
      var usdPrice = Number(card.getAttribute('data-subscription-card-price-usd'));
      if (!Number.isFinite(usdPrice) || usdPrice <= 0) return;

      setText(card.querySelector('[data-subscription-card-current-price]'), Math.ceil((usdPrice * rate) / 100) * 100, currency);

      var usdCompare = Number(card.getAttribute('data-subscription-card-compare-price-usd'));
      if (Number.isFinite(usdCompare) && usdCompare > 0) {
        setText(card.querySelector('[data-subscription-card-compare-price]'), Math.ceil((usdCompare * rate) / 100) * 100, currency);
      }
    });

    return true;
  }

  function run() {
    if (!convert(document) && retries < maxRetries) {
      retries += 1;
      window.setTimeout(run, 250);
    }
  }

  function observeNewCards() {
    if (!document.body || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        convert(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      observeNewCards();
    });
  } else {
    run();
    observeNewCards();
  }

  document.addEventListener('shopify:section:load', function (event) {
    convert(event.target);
  });
}());
